import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import Header from '../components/Header';

function TermsOfServicePage() {
  return (
    <div className="TermsOfServicePage">
      <Header />
      <Container sx={{ padding: '4rem 0', color: '#fff' }}>
        <Typography variant="h2" align="center" sx={{ mb: 3 }}>
          Terms of Service
        </Typography>
        <Box sx={{ maxHeight: '70vh', overflowY: 'auto', pr: 2 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>1. Acceptance of Terms</strong>
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            By accessing and using BIM Analytics, you accept and agree to be bound by the terms and provisions of this
            agreement. When using our services, you shall be subject to any posted guidelines or rules applicable to such
            services.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>2. Modification of Terms</strong>
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            BIM Analytics reserves the right to change or modify these terms at any time without prior notice. Your
            continued use of the service constitutes your agreement to any such changes.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>3. Use of the Service</strong>
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            You agree to use the service only for purposes that are permitted by these Terms and any applicable law,
            regulation, or generally accepted practices in your jurisdiction.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>4. Disclaimer of Warranties</strong>
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            The service is provided on an "as is" and "as available" basis. BIM Analytics disclaims all warranties,
            whether express or implied.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>5. Limitation of Liability</strong>
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            In no event shall BIM Analytics be liable for any direct, indirect, incidental, special, consequential, or
            exemplary damages arising out of or in connection with your use of the service.
          </Typography>
        </Box>
      </Container>
    </div>
  );
}

export default TermsOfServicePage;
